import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { IObjectKey, IPlatformUser } from '@nova/common-interfaces';
import { FUNCTION_NAME } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class SystemPlatformUserService extends CommonService<IPlatformUser, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_INSERT;
  public override mergeFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_MERGE;
  public override updateFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_UPDATE;
  public override getAllFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GETALL;
  public override getFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GET;
  public override getKeysFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GETKEYS;

  constructor(functions: Functions) {
    super(functions);
  }
}
